import { useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSpecialTextures } from '../../../../store/actions/texture.action';
import { fetchSuppliers } from '../../../../store/actions/supplier.action';
import {
  setCurrentSupplier,
  toggleSpecialTexture,
} from '../../../../store/reducers/supplier.reducer';
import SelectionSupplier from '../SelectionSuplier/SelectionSuplier';
import ButtonTertiarySmall from '../../../../components/common/ButtonTertiary/ButtonTertiarySmall';
import { Icon } from '../../../../components/icon/icon';
import { Trans, useTranslation } from 'react-i18next';
import { DesignerPageContext } from '../../DesignerPage';
import { openModal } from '../../../../components/common/Modal/openModal';
import ButtonSecondaryLarge from '../../../../components/common/ButtonSecondary/ButtonSecondaryLarge';
import ButtonPrimaryLarge from '../../../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import { openMessageError } from '../../../../components/common/Message/openMessageError';
import RightSupplierMenu from '../RightSupplierMenu/RightSupplierMenu';
import { getSupplierFromModules } from '../../../../utils/modules/ModuleUtils';
import Tag from '../../../../components/common/Tag/Tag';

export const TabSpecialTexture = ({
  supplierId,
  supplier,
  setSupplier,
  suppliers,
  textureType,
  type,
  texture,
  setTexture,
  canUseAcrylic,
}) => {
  const { sceneManager } = useContext(DesignerPageContext);
  const { specialTextures } = useSelector(state => state.texture);
  const { specialTexture } = useSelector(state => state.supplier);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [specialTab, setSpecialTab] = useState('normal');
  const [openSupplier, setOpenSupplier] = useState(false);

  useEffect(() => {
    if (!specialTextures.data.length && textureType?.split(',').includes('M')) {
      dispatch(
        fetchSpecialTextures({
          limit: 20,
          offset: 0,
          special: 'yes',
          priceCollectionTypes: 'M',
        })
      ).then(action => {
        try {
          const { data } = action.payload;
          if (!data.length) {
            dispatch(toggleSpecialTexture(false));
          } else if (supplierId?.materialType === 'M') {
            dispatch(toggleSpecialTexture(true));
          }
        } catch (error) {
          openMessageError({ content: t("Can't load special texture") });
          dispatch(toggleSpecialTexture(false));
        }
      });
    } else if (!textureType?.split(',').includes('M')) {
      dispatch(toggleSpecialTexture(false));
    }
  }, [textureType]);

  // useEffect(() => {
  //     if (supplier?.id !== supplierId?.id) {
  //         const temp = Object.entries(suppliers.data)
  //             ?.reduce((prev, curr) => [...prev, curr[1]], [])
  //             ?.flat()
  //             ?.filter(
  //                 (item, index, array) =>
  //                     supplierId &&
  //                     item?.id === supplierId?.id &&
  //                     array.findIndex(ar => item?.id === ar?.id) === index
  //             );
  //         setSupplier(temp?.[0]);
  //     }

  // }, [supplierId, suppliers.data]);

  useEffect(() => {
    if (textureType && !suppliers.data[textureType]) {
      dispatch(fetchSuppliers({ textureType: textureType })).then(action => {
        // if (action.payload && !supplierId[textureType]?.id) {
        //     setSupplier(action.payload[textureType]?.[0]);
        //     const supplier = action.payload[textureType]?.[0];
        //     let materialType = supplier?.support_types?.[0];
        //     if (supplier) {
        //         dispatch(
        //             setCurrentSupplier({
        //                 [type]: {
        //                     ...(supplierId ?? {}),
        //                     [textureType]: { id: supplier.id, materialType, special: supplierId[textureType]?.special },
        //                 },
        //             })
        //         );
        //     }
        // }
      });
    } else if (
      suppliers.data[textureType] &&
      !supplierId?.id &&
      textureType?.split(',').includes('M')
    ) {
      const kesS6 = suppliers.data[textureType].find(
        item => item.name === 'KES S6'
      );
      if (kesS6) {
        let materialType = 'M';
        setSupplier({ ...kesS6, materialType });
        if (kesS6) {
          dispatch(
            setCurrentSupplier({
              [type]: {
                ...(supplierId ?? {}),
                ...{
                  id: kesS6.id,
                  materialType,
                  special: supplierId?.special ?? false,
                },
              },
            })
          );
        }
      }
    } else if (suppliers.data[textureType] && !supplierId?.id) {
      const supplier = suppliers.data[textureType][0];
      if (supplier) {
        let materialType = supplier?.support_types?.[0];
        setSupplier({ ...supplier, materialType });
        if (supplier) {
          dispatch(
            setCurrentSupplier({
              [type]: {
                ...(supplierId ?? {}),
                ...{
                  id: supplier.id,
                  materialType,
                  special: supplierId?.special ?? false,
                },
              },
            })
          );
        }
      }
    }
  }, [suppliers.data[textureType], supplierId, textureType]);

  useEffect(() => {
    if (supplierId?.id) {
      const supplier = suppliers.data[textureType]?.find(
        item => item.id === supplierId?.id
      );
      if (supplier) {
        setSupplier({ ...supplier, materialType: supplierId?.materialType });
      }
    }
  }, [supplierId, suppliers.data[textureType]]);

  useEffect(() => {
    setSpecialTab(specialTexture[type] ? 'special' : 'normal');
  }, [specialTexture]);

  // useEffect(() => {
  //     if (supplierId?.special !== undefined && (texture || !supplier)) {
  //         const special = supplierId?.special
  //         dispatch(toggleSpecialTexture(special))
  //     }
  // }, [supplierId, specialTextures.data,])

  const popupConfirmChangeSpecialTab = useCallback(
    special => {
      // if (!texture?.textureId) {
      // dispatch(toggleSpecialTexture(special))
      // }
      // else {
      const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
      const currSuppliers = getSupplierFromModules(modules);
      // 1. Tạo danh sách giả định bao gồm các nhà cung cấp hiện tại + nhà cung cấp mới (nếu chưa có)
      const hypotheticalSuppliers = currSuppliers;
      // 2. Lọc ra danh sách các nhà cung cấp KHÔNG PHẢI là 'Plastic' và 'Plywood'
      // 'Acrylic' là loại đặc biệt có thể bỏ qua
      const nonPlasticSuppliers = hypotheticalSuppliers.filter(
        s =>
          !['Plastic', 'Plywood', 'Acrylic'].some(item =>
            s?.materialType?.includes(item)
          )
      );

      const uniqueSuppliers = [...new Set(nonPlasticSuppliers.map(s => s?.id))];

      const hasKesS6 = uniqueSuppliers.some(item => item.name === 'KES S6');
      if (hasKesS6 && special) {
        const result = openModal({
          title: (
            <div className="flex justify-between items-center self-stretch">
              <h4 className="text-title-large">{t('Warning.default')}</h4>
            </div>
          ),
          content: (
            <span className="text-body-medium">
              <Trans
                i18nKey="After clicking the <strong>confirm</strong> button, the old color codes will be deleted."
                components={{
                  strong: <strong />,
                }}
              />
            </span>
          ),
          centered: true,
          width: 400,
          classNames: {
            header: '!p-16 !m-0',
            body: '!px-16 gap-0',
            footer: '!p-16 gap-16 items-end flex justify-end',
          },
          footer: (
            <div className="flex justify-end items-center gap-16 self-stretch">
              <ButtonSecondaryLarge
                title={t('Cancel')}
                onClick={() => result.destroy()}
              />
              <ButtonPrimaryLarge
                title={t('Confirm')}
                onClick={() => {
                  const modules =
                    sceneManager?.cabinetManager?.currentCabinet?.modules;
                  const moduleEntries = Array.from(modules.entries());
                  moduleEntries.forEach(([moduleId, module]) => {
                    sceneManager?.textureController?.clearTexture?.(module);
                  });

                  setTimeout(async () => {
                    await sceneManager.calculateTotalCost?.({});
                  }, 100);
                  setTexture();

                  dispatch(toggleSpecialTexture(special));
                  const kesS6 = suppliers.data[textureType].find(
                    item => item.name === 'KES S6'
                  );
                  if (kesS6) {
                    let materialType = 'M';
                    setSupplier({ ...kesS6, materialType });
                    if (kesS6) {
                      dispatch(
                        setCurrentSupplier({
                          [type]: {
                            ...(supplierId ?? {}),
                            ...{ id: kesS6.id, materialType, special: special },
                          },
                        })
                      );
                    }
                  }
                  result.destroy();
                }}
              />
            </div>
          ),
        });

        // }
      } else {
        dispatch(toggleSpecialTexture(special));
        dispatch(
          setCurrentSupplier({
            [type]: {
              ...{
                ...(supplierId ?? {}),
                special: special,
              },
            },
          })
        );
      }
    },
    [texture, sceneManager, supplier, type, suppliers.data[textureType]]
  );

  return {
    specialTab,
    setSpecialTab,
    renderSupplierMenu: () => {
      return (
        <RightSupplierMenu
          open={openSupplier}
          onClose={supplier => {
            setOpenSupplier(false);
            // if (!supplier && open) onClose?.();
          }}
          type={type}
          canUseAcrylic={canUseAcrylic}
        />
      );
    },
    renderContent: () => {
      return (
        <>
          {specialTextures.data.length &&
          textureType?.split(',').includes('M') ? (
            <SelectionSupplier
              icon={
                <span className="w-[24px] h-[24px] text-black-medium">
                  <Icon.ICStack />
                </span>
              }
              title={t('Available colors') + ' (KES)'}
              description={
                <div className="flex items-center justify-start gap-[4px] self-stretch">
                  <Tag
                    label={
                      <span className="text-label-small text-white truncate">
                        {t('Affordable')}
                      </span>
                    }
                    className={
                      'py-[2px] px-[4px] bg-Accents-Red rounded-[4px] h-[16px]'
                    }
                  />
                  {/* <Tag
                    label={
                      <span className="text-label-small text-white truncate">
                        {t('Giao hàng nhanh 5-7 ngày')}
                      </span>
                    }
                    className={
                      'py-[2px] px-[4px] bg-Accents-Red rounded-[4px] h-[16px]'
                    }
                  /> */}
                </div>
              }
              className={'self-stretch'}
              onClick={() => {
                if (specialTab === 'normal') {
                  popupConfirmChangeSpecialTab(true);
                }
              }}
              active={specialTab === 'special'}
            />
          ) : null}
          {/* {
                    supplier ? (
                        <> */}
          {(() => {
            const typeTexture = supplier?.materialType;
            let description = null;
            if (typeTexture === 'L') description = 'Moisture-resistant MDF';
            else if (typeTexture === 'M') description = 'Melamine-coated MDF';
            else description = typeTexture;
            return (
              <SelectionSupplier
                src={supplier?.icon_url}
                title={supplier?.name + '-' + typeTexture}
                description={
                  <div className="flex items-center justify-start gap-[4px] self-stretch">
                    <Tag
                      label={
                        <span className="text-label-small text-black-high truncate">
                          {t('Standard Price')}
                        </span>
                      }
                      className={
                        'py-[2px] px-[4px] bg-fills-primary rounded-[4px] h-[16px]'
                      }
                    />
                    {/* <Tag
                      label={
                        <span className="text-label-small text-black-high truncate">
                          {t('Giao hàng 14 - 24 ngày')}
                        </span>
                      }
                      className={
                        'py-[2px] px-[4px] bg-fills-primary rounded-[4px] h-[16px]'
                      }
                    /> */}
                  </div>
                }
                className={'self-stretch relative'}
                onClick={() => {
                  if (specialTab === 'special') {
                    popupConfirmChangeSpecialTab(false);
                  }
                }}
                active={specialTab === 'normal'}
                actions={
                  <ButtonTertiarySmall
                    title={t('Change')}
                    onClick={e => {
                      setOpenSupplier(true);
                    }}
                    className={'absolute top-[4px] right-[4px]'}
                  />
                }
              />
            );
          })()}
          {/* </>
                    ) : null
                } */}
        </>
      );
    },
  };
};
